exports = module.exports = require("../../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskPage/CollectionView/CollectionView.css
// module id = 657
// module chunks = 0